
import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Ticket } from "@/types";
import { ClipboardList } from "lucide-react";
import { format } from "date-fns";

interface EntryLogsProps {
  recentEntries: Ticket[];
}

export const EntryLogs = ({ recentEntries }: EntryLogsProps) => {
  return (
    <Card className="glass-card">
      <div className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <ClipboardList className="w-5 h-5" />
          <h2 className="text-xl font-semibold">Entry Logs</h2>
        </div>
        <ScrollArea className="h-[500px] rounded-md border">
          {recentEntries.length === 0 ? (
            <div className="p-4 text-center text-muted-foreground">
              No entries recorded yet
            </div>
          ) : (
            <div className="space-y-2 p-4">
              {recentEntries.map((ticket) => (
                <div
                  key={ticket.id + Date.now()}
                  className="flex items-center justify-between p-3 bg-background rounded-lg animate-in"
                >
                  <div>
                    <p className="font-medium">Ticket #{ticket.id}</p>
                    <p className="text-sm text-muted-foreground">
                      Event #{ticket.eventId}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      Purchased: {format(new Date(ticket.purchaseDate), 'PPP')}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-muted-foreground">
                      {new Date().toLocaleTimeString()}
                    </p>
                    <p className={`text-sm ${
                      ticket.status === "valid" ? "text-green-500" : 
                      ticket.status === "used" ? "text-yellow-500" : 
                      "text-red-500"
                    }`}>
                      {ticket.status.toUpperCase()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </ScrollArea>
      </div>
    </Card>
  );
};
